var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDescription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.875 12 16.3 17.075q-.3.425-.775.675-.475.25-1.025.25H5.725q-.675 0-1.137-.475-.463-.475-.463-1.15v-8.75q0-.675.463-1.15Q5.05 6 5.725 6H14.5q.55 0 1.013.262.462.263.787.713Zm-1.2 0L15.45 7.5q-.15-.2-.4-.35Q14.8 7 14.5 7H5.725q-.225 0-.413.188-.187.187-.187.437v8.75q0 .25.187.437.188.188.413.188H14.5q.3 0 .55-.15.25-.15.4-.35Zm-13.55 0v5V7v.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescription);
export default __webpack_public_path__ + "static/media/description.28f219ec73cf9ba2fd4163da8e6a8914.svg";
export { ForwardRef as ReactComponent };